var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41797 10.5C2.41797 10.9142 2.08218 11.25 1.66797 11.25C1.25376 11.25 0.917969 10.9142 0.917969 10.5H2.41797ZM11.668 4.70981L12.2054 4.18662L12.7147 4.70981L12.2054 5.23299L11.668 4.70981ZM11.668 5.47235H4.82586V3.97235H11.668V5.47235ZM2.41797 7.96594V10.5H0.917969V7.96594H2.41797ZM4.82586 5.47235C3.51482 5.47235 2.41797 6.56971 2.41797 7.96594H0.917969C0.917969 5.7794 2.64879 3.97235 4.82586 3.97235V5.47235ZM9.08035 0.976817L12.2054 4.18662L11.1306 5.23299L8.00559 2.02318L9.08035 0.976817ZM12.2054 5.23299L9.08035 8.4428L8.00559 7.39643L11.1306 4.18662L12.2054 5.23299Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoSmall);
export default __webpack_public_path__ + "static/media/redo-small.e7a59f845a9658806bddef08fe69e99e.svg";
export { ForwardRef as ReactComponent };